/* eslint-disable react/no-danger */
import { Grid, Modal, Button } from '../../../../canvasComponents/index';
import { ReactSVG } from 'react-svg';
import { FormattedMessage, IntlProvider } from 'react-intl';
import { SelectedPartsMapping } from '../Mapping/SelectedPartsMapping';
import './AudaTargetModal.scss';
import { setPartColor, severityValues, removeSelectedPanel } from '../AudaTarget/AudaTargetScript';

export function AudaTargetModal({
  showModal,
  setShowModal,
  selectedPartModal,
  setAudaTargetValue,
  localParams,
  intl,
  dataImage,
}) {
  const saveModal = () => {
    setAudaTargetValue();
    setShowModal(false);
  };

  const onChangeSlider = (e) => {
    setPartColor(selectedPartModal, severityValues[e.target.value], true);
  };

  const removeSelectedPanelHandler = (selectedPart) => {
    removeSelectedPanel(selectedPart);
    setAudaTargetValue();
    setShowModal(false);
  };

  return showModal ? (
    <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
      <Modal
        id="audatarget_modal"
        isOpen={showModal}
        onRequestClose={() => removeSelectedPanelHandler()}
      >
        <Grid>
          <Grid.Row mt4>
            <h2 style={{ textAlign: 'center', color: 'black', fontWeight: 'bold' }}><FormattedMessage id="How severe is the damage?" defaultMessage="How severe is the damage?" /></h2>
          </Grid.Row>
          <Grid.Row mt4 mb4>
            <h4 style={{ textAlign: 'center', color: 'black' }}><FormattedMessage id="Drag the slider to indicate the level of damage" defaultMessage="Drag the slider to indicate the level of damage" /></h4>
          </Grid.Row>
          {dataImage && (
            <ReactSVG
              className="modal-img"
              id="modal-img"
              src={dataImage}
            />
          )}
          {selectedPartModal !== '' ? (
            <Grid.Row mt3 mb3>
              <h4>{intl.formatMessage({ id: `${SelectedPartsMapping(selectedPartModal)}`, defaultValue: `${SelectedPartsMapping(selectedPartModal)}` })}</h4>
            </Grid.Row>
          ) : null}
          <Grid.Row mt3 mb3>
            <input type="range" min={0} max={2} defaultValue={0} className="audaTargetSlider" id="severitySlider" style={{ background: 'linear-gradient(to right, #7ba428 0%,#ffc90e 50%,#ffc90e 50%,#ff1a1a 100%)', border: 'solid 2px black', borderRadius: '5px', height: '20px', width: '100%', outline: 'none', WebkitAppearance: 'none' }} onChange={onChangeSlider} />
          </Grid.Row>
          <Grid.Row mt1 mb3>
            <div
              id="severityLabel"
              style={{
                padding: '10px',
                fontSize: '1rem',
                color: 'black',
                display: 'flex',
                justifyContent: 'start',
                whiteSpace: 'pre-line',
                verticalAlign: 'bottom',
              }}
            />
          </Grid.Row>
          <Grid.Row>
            <Button
              primary
              id="modal-save-button"
              onClick={() => saveModal()}
            ><FormattedMessage id="Save" defaultMessage="Save" />
            </Button>
          </Grid.Row>
          <Grid.Row>
            <div className="center-v removeSelectedPanel">
              <Button
                className="btn save-continue-later"
                onClick={() => removeSelectedPanelHandler(selectedPartModal)}
              > <FormattedMessage id="Remove selected panel" defaultMessage="Remove selected panel" />
              </Button>
            </div>
          </Grid.Row>
        </Grid>
      </Modal>
    </IntlProvider>
  ) : null;
}
